import { Refine_Resources } from "../Data/E_Offer";

const slugify = (value = "") =>
  value
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");

const defaultBySlug = Refine_Resources.reduce((map, resource) => {
  const slug = resource.id || slugify(resource.title);
  map[slug] = { ...resource, slug };
  return map;
}, {});

export const normalizeRefinePage = (page = {}) => {
  const slug = page.slug || page.id || slugify(page.title);
  const fallback = defaultBySlug[slug] || {};

  return {
    ...fallback,
    ...page,
    id: slug,
    slug,
    image: page.image || fallback.image,
    documentFlow: Array.isArray(page.documentFlow) ? page.documentFlow : fallback.documentFlow || [],
    sections: Array.isArray(page.sections) ? page.sections : fallback.sections || [],
    externalLinks: Array.isArray(page.externalLinks) ? page.externalLinks : fallback.externalLinks || [],
  };
};

export const defaultRefinePages = Refine_Resources.map(normalizeRefinePage);

export async function fetchRefinePages() {
  const response = await fetch("/api/refine-education/pages", {
    credentials: "include",
  });
  const result = await response.json();

  if (!response.ok || !result.success || !Array.isArray(result.pages)) {
    const error = new Error(result.message || "Unable to load Refine pages");
    error.status = response.status;
    throw error;
  }

  return result.pages.map(normalizeRefinePage);
}

export async function fetchRefinePage(slug) {
  const response = await fetch(`/api/refine-education/pages/${slug}`, {
    credentials: "include",
  });
  const result = await response.json();

  if (!response.ok || !result.success || !result.page) {
    const error = new Error(result.message || "Unable to load Refine page");
    error.status = response.status;
    throw error;
  }

  return normalizeRefinePage(result.page);
}

export function findDefaultRefinePage(slugOrTitle) {
  const slug = slugify(slugOrTitle);
  return defaultBySlug[slug] || defaultRefinePages.find((item) => slugify(item.title) === slug);
}

export { slugify };
